import { atom } from "jotai";

export const leadAtom = atom({});
export const isLeadLoadingAtom = atom(false);
export const isSearchingFilesAtom = atom(null);
export const isFilesLoadedAtom = atom(false);
